(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FeedbackController', FeedbackController);

    FeedbackController.$inject = ['$scope', 'Principal', '$state','Feedback','AlertService', '$timeout'];

    function FeedbackController ($scope, Principal, $state,Feedback,AlertServic, $timeout) {

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 400
        };
        $scope.sendFeedBack = function(){
        	$scope.messageError = false;
        	if(!$scope.feedback.message || $scope.feedback.message.length<1 || $scope.feedback.message == ""){
        		$scope.messageError = true;
        		return;
        	}
            Feedback.saveFeedbackForm($scope.feedback, function(responce){
                if(responce){
                    $scope.isSaved = true;
                	init();
                   // AlertService.success("success","","top");
                }
            });
        };
        var init = function(){
        	 Principal.identity().then(function(account) {
                 $scope.feedback = {};
                 $scope.feedback.name = account.firstName +" "+account.lastName;
                 $scope.feedback.email = account.email;
                 $scope.feedback.siteId=account.siteId;

             });
            $timeout( function(){
                $scope.isSaved = false;
            }, 10000 );
        };
        init();
    }
})();
